import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import React, { useEffect, useState } from "react";

import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import LineTypeLinked from "./LineTypeLinked";

export default function LineTypeLinks(props) {
  const [loading, setLoading] = useState(false);
  // const user = useContext(UserContext);
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    button: {
      margin: theme.spacing(1),
    },

    center: {
      margin: "0 auto",
      border: "1px grey black",
      textAlign: "center",
      width: "75%",
      "& .MuiTextField-root": {
        margin: theme.spacing(1),
        width: 200,
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
  }));
  const classes = useStyles();
  console.log("PROPS====== PLAYERLineTypeLinkSPORT url props", props);
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const [notLinkedLineType, setNotLinkedLineType] = React.useState();
  const [linkedLineType, setLinkedLineType] = React.useState();

  const GetLinkedLineTypes = () => {
    axios({
      method: "post",
      url:
        process.env.REACT_APP_API2_URL +
        "/LineType/LineTypeLinks_GetNotLinked?idLineType=" +
        props.LineType.idLineType +
        "&idUser=" +
        userInfo.userId,
      //url:'https://localhost:44337/api/LineType/LineTypeLinks_GetNotLinked?idLineType=' +props.LineType.IdLineType +'&idUser=' +userInfo.userId,
      /*  REPLACE WITH SELECT DATA */
    }).then((response) => {
      console.log("NOT LINKED LINETYPES =======>", response.data);
      setNotLinkedLineType(response.data);
    });
  };

  const GetUnlinkedLineTypes = () => {
    axios({
      method: "post",
      url:
        process.env.REACT_APP_API2_URL +
        "/LineType/LineTypeLinks_GetLinked?idLineType=" +
        props.LineType.idLineType +
        "&idUser=" +
        userInfo.userId,
      //url:'https://localhost:44337/api/LineType/LineTypeLinks_GetLinked?idLineType=' +props.LineType.IdLineType +'&idUser=' + userInfo.userId,
      /*  REPLACE WITH SELECT DATA */
    }).then((response) => {
      console.log("LINKED LINETYPES =======>", response.data);
      setLinkedLineType(response.data);
    });
  };

  useEffect(() => {
    GetLinkedLineTypes();
  }, [props.LineType]);

  useEffect(() => {
    GetUnlinkedLineTypes();
  }, [props.LineType]);

  const options = {
    beforeShowError: (type, msg) => {
      this.setState({ errType: type, errMsg: msg });
      // return false or do not return will not trigger the toastr,
      // if you want the toastr popup, you should return true always.
    },
  };

  const isExpandableRow = (row) => {
    console.log("isExpandableRow ", row);
    return true;
  };
  const expandComponent = (row) => {
    console.log("expandComponent ", row);
    return <BSTable data={row} />;
  };

  const onRowSelect = (row, isSelected, e) => {
    let request = {
      IdLineTypeOut: row.idLineType,
      IdLineTypeIn: props.LineType.idLineType,
      IdUser: userInfo.userId,
    };
    if (isSelected) {
      setLoading(true);
      axios({
        method: "post",
        url: process.env.REACT_APP_API2_URL + "/LineType/LineTypeLinks_Insert",
        //url: 'https://localhost:44337/api/LineType/LineTypeLinks_Insert',
        /*  REPLACE WITH SELECT DATA */
        data: request,
      }).then((response) => {
        if (response.data === -1) {
          setLoading(false);
          GetLinkedLineTypes();
          GetUnlinkedLineTypes();
        }
      });
    }
  };

  const onSelectAll = (isSelected, rows) => {
    if (isSelected) {
      let request = {
        IdLineTypeOut: -1,
        IdLineTypeIn: props.LineType.idLineType,
        IdUser: userInfo.userId,
      };
      setLoading(true);
      axios({
        method: "post",
        url: process.env.REACT_APP_API2_URL + "/LineType/LineTypeLinks_Insert",
        //url: 'https://localhost:44337/api/LineType/LineTypeLinks_Insert',
        /*  REPLACE WITH SELECT DATA */
        data: request,
      }).then((response) => {
        console.log("response", response);
        if (response.data === -1) {
          setLoading(false);
          GetLinkedLineTypes();
          GetUnlinkedLineTypes();
        }
      });
    }
  };

  const selectRowProp = {
    mode: "checkbox",
    clickToSelect: true,
    onSelect: onRowSelect,
    onSelectAll: onSelectAll,
  };

  const onRowUnlinkedSelect = (row, isSelected, e) => {
    if (isSelected) {
      let request = {
        IdLineTypeOut: row.idLineType,
        IdLineTypeIn: props.LineType.idLineType,
        IdUser: userInfo.userId,
      };
      setLoading(true);
      axios({
        method: "post",
        url: process.env.REACT_APP_API2_URL + "/LineType/LineTypeLinks_Delete",
        //url: 'https://localhost:44337/api/LineType/LineTypeLinks_Delete',
        /*  REPLACE WITH SELECT DATA */
        data: request,
      }).then((response) => {
        if (response.data === -1) {
          setLoading(false);
          GetLinkedLineTypes();
          GetUnlinkedLineTypes();
        }
      });
    }
  };

  const onUnlinkedSelectAll = (isSelected, rows) => {
    if (isSelected) {
      let request = {
        IdLineTypeOut: -1,
        IdLineTypeIn: props.LineType.idLineType,
        IdUser: userInfo.userId,
      };
      setLoading(true);
      axios({
        method: "post",
        url: process.env.REACT_APP_API2_URL + "/LineType/LineTypeLinks_Delete",
        //url: 'https://localhost:44337/api/LineType/LineTypeLinks_Delete',
        /*  REPLACE WITH SELECT DATA */
        data: request,
      }).then((response) => {
        if (response.data === -1) {
          setLoading(false);
          GetLinkedLineTypes();
          GetUnlinkedLineTypes();
        }
      });
    }
  };

  class BSTable extends React.Component {
    render() {
      if (this.props.data) {
        return (
          <Table className="table-open-bets">
            <TableRow>
              <LineTypeLinked
                idLineTypeOut={this.props.data.idLineType}
                idLineTypeIn={props.LineType.idLineType}
              ></LineTypeLinked>
            </TableRow>
          </Table>
        );
      } else {
        return <p>?</p>;
      }
    }
  }

  const moveFormatter = (direction, cell, row) => {
    const onClick = (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (direction) {
        onRowSelect(row, true);
      } else {
        onRowUnlinkedSelect(row, true);
      }
    };

    return (
      <button
        disabled={loading}
        onClick={onClick}
        className="relative flex items-center justify-center gap-1 p-2 overflow-hidden text-sm font-semibold leading-6 text-gray-500 bg-gray-100 rounded-md cursor-pointer hover:bg-gray-200 hover:text-black w-max h-max"
      >
        <i
          className={`fa-solid leading-3 text-center text-gray-400 font-semibold text-xs ${direction ? "fa-chevron-right" : "fa-chevron-left"
            }`}
        ></i>
      </button>
    );
  };

  return (
    <div className="flex flex-row items-start gap-4">
      <div className="flex flex-col items-center justify-center">
        <h3>Available Line Types</h3>
        <BootstrapTable data={notLinkedLineType} options={options}>
          <TableHeaderColumn
            visible="none"
            isKey={true}
            hidden
            dataField="idLineType"
          >
            IdLineType
          </TableHeaderColumn>
          <TableHeaderColumn
            filter={{ type: "TextFilter", delay: 1000 }}
            dataField="description"
          >
            Description
          </TableHeaderColumn>
          <TableHeaderColumn
            dataFormat={(cell, row) => moveFormatter(true, cell, row)} // Use the custom formatter function for the cell content
            headerAlign="center" // Center align the header
            dataAlign="center" // Center align the column content
            width="50" // Attempt to set a minimal width; adjust as necessary
          >
            <button
              disabled={loading}
              onClick={onSelectAll}
              className="relative flex items-center justify-center gap-1 p-2 overflow-hidden text-sm font-semibold leading-6 text-gray-500 bg-gray-100 rounded-md cursor-pointer hover:bg-gray-200 hover:text-black w-max h-max"
            >
              <i className="text-xs font-semibold leading-3 text-center text-gray-400 fa-solid fa-chevron-right"></i>
            </button>
          </TableHeaderColumn>
        </BootstrapTable>
      </div>
      <div className="flex flex-col items-center justify-center">
        <h3>Linked Line Types</h3>
        <BootstrapTable
          data={linkedLineType}
          options={options}
          expandableRow={isExpandableRow}
          expandComponent={expandComponent}
        >
          <TableHeaderColumn
            visible="none"
            isKey={true}
            hidden
            dataField="idLineType"
          >
            IdLineType
          </TableHeaderColumn>
          <TableHeaderColumn
            dataFormat={(cell, row) => moveFormatter(false, cell, row)} // Use the custom formatter function for the cell content
            headerAlign="center" // Center align the header
            dataAlign="center" // Center align the column content
            width="50" // Attempt to set a minimal width; adjust as necessary
          >
            <button
              disabled={loading}
              onClick={onUnlinkedSelectAll}
              className="relative flex items-center justify-center gap-1 p-2 overflow-hidden text-sm font-semibold leading-6 text-gray-500 bg-gray-100 rounded-md cursor-pointer hover:bg-gray-200 hover:text-black w-max h-max"
            >
              <i className="text-xs font-semibold leading-3 text-center text-gray-400 fa-solid fa-chevron-left"></i>
            </button>
          </TableHeaderColumn>
          <TableHeaderColumn
            filter={{ type: "TextFilter", delay: 1000 }}
            dataField="description"
          >
            Description
          </TableHeaderColumn>
        </BootstrapTable>
      </div>
    </div>
  );
}
